<div class="tt-l-masonry" :style="layoutStyles">
  <slot></slot>
</div>


// WEBPACK FOOTER //
// ./src/layouts/masonry/layout.html